import axios from 'axios'
import {AuthModel, AuthEmailModel, UserModel, VerificationType} from './_models'
import { SettingsResponse } from '../../../_apiModels/_settingsModels'

const API_URL = process.env.REACT_APP_API_URL

// Server should return AuthModel
export function login(email: string, password: string) {
    return axios.post<AuthEmailModel>(`${API_URL}/authenticate/login`, {
    Username: email,
    Password: password,
  })
}

// Server should return VerificationType
export function getVerificationType(userName: string) {
    return axios.post<VerificationType>(`${API_URL}/authenticate/getVerificationType`, {
        Username: userName
    })
}

// Server should return AuthModel
export function verifyTwoStep(code: string, userName: string) {
    return axios.post<AuthModel>(`${API_URL}/authenticate/verifyTwoStep`, {
        Code: code,
        Username: userName
    })
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
    return axios.post(`${API_URL}/authenticate/register`, {
    Username: email,
    Email: email,
    Password: password,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function forgotPassword(email: string) {
    return axios.post<AuthEmailModel>(`${API_URL}/authenticate/forgotPassword`, {
      email: email
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function resetPassword(token: any, email: string, newPassword: string) {
    return axios.post<{ result: boolean }>(`${API_URL}/authenticate/resetPassword`, {
        token: token,
        email: email,
        password: newPassword
    })
}
export function stopImpersonationUser() {
    return axios.post(`${API_URL}/authenticate/stopImpersonation`, {});
}
export function logoutUser() {
    return axios.post(`${API_URL}/authenticate/logout`, {});
}


export function getUser() {
    return axios.get<UserModel>(`${API_URL}/authenticate/getUser`)
}

export function getInstanceSettings() {
    return axios.get<SettingsResponse>(`${API_URL}/authenticate/getInstanceSettings`)
}
